<template>
	<div class="footer" :class="{ablut:status=='isIndex',fixed:status=='isPaySuccess'}">
    <p>Copyright © 2020  |  <a target="_blank" class="a-style" href="https://beian.miit.gov.cn">琼ICP备18001822号-3</a> | 海南梯度网络科技有限公司</p>
	</div>
</template>
<script>
	export default {
		name: 'bfooter',
		data (){
			return {

			}
		},
		computed:{
	    status(){
	      return this.$store.state.status;
	    }
	  }
	}
</script>

<style scoped>
  .footer{
    width: 100%;
    height: 76px;
    display: inline-block;
  }
	.footer.fixed{
		position: fixed;
		bottom: 0;
		left: 0;
	}

	.footer.ablut{
		left: 0;
		bottom: 0;
	}

  .footer p:first-child{
    margin-top: 20px;
  }

  .footer p{
    font-family: PingFangSC-Medium;
    font-size: 10px;
    color: #232323;
    letter-spacing: 0;
    text-align: center;
		padding-top: 20px;
  }

	.a-style{
		color: #232323;
		text-decoration: none;
	}
</style>



// WEBPACK FOOTER //
// src/components/footer.vue